module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-btn-toggle u-relative u-vacuum u-click-area--xxs",
    class: {
      'is-active': _vm.active
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm._click
    }
  }, [_c('img', {
    staticClass: "c-btn-toggle__btn u-absolute",
    attrs: {
      "src": require("../../../assets/header/btn-hide.png"),
      "alt": "Activate"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-btn-toggle__hover u-absolute u-pos-tl",
    attrs: {
      "src": require("../../../assets/header/btn-hide-bg--hover.png"),
      "alt": "Toggle background"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b26e7ec"}!./src/scripts/components/app-btn-toggle/template.html
// module id = 923
// module chunks = 0